import { Button, Fab, IconButton, Menu } from '@mui/material';
import React, { Children, cloneElement, useEffect, useState } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export default function DropDownButton({ label, children, color }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [newChildren, setNewChildren] = useState([]);

    useEffect(() => {
        let newChildrenAux = [];

        for (const child of Children.toArray(children)) {
            newChildrenAux.push(cloneElement(child, {
                onClick: () => {
                    child.props.onClick()
                    handleClose()
                }
            }));
        }

        setNewChildren(newChildrenAux);
    }, [children]);

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {label ?
                <Button
                    variant="contained"
                    disableElevation
                    onClick={handleClick}
                    endIcon={
                        <KeyboardArrowDownIcon sx={{
                            transition: 'transform 0.2s ease-in-out',
                            transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
                        }} />
                    }
                    color={color}
                >{label}</Button>
                :
                <>
                    {color ?
                        <Fab
                            size='small'
                            color={color}
                            onClick={handleClick}
                        >
                            <KeyboardArrowDownIcon sx={{
                                transition: 'transform 0.2s ease-in-out',
                                transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
                            }} />
                        </Fab>
                        :
                        <IconButton
                            onClick={handleClick}
                        >
                            <KeyboardArrowDownIcon sx={{
                                transition: 'transform 0.2s ease-in-out',
                                transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
                            }} />
                        </IconButton>
                    }
                </>
            }
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {newChildren}
            </Menu>
        </div>
    )
}
